
let youtubePlayer;
let ytPlayer;
let pageHandle;
let done = false;

const BlogVideoModel = {
  init() {
    const _this = this;
    let idx = 0;
    this.max = +$(".blog-video-model").data("total");

    const io = new IntersectionObserver((entries) => {
      entries.forEach(item => {
        if (item.isIntersecting) {
          const $button = $('.blog-video-model .bvm-product-btn')
          const sku = $button.data('sku');
          const price = $button.data("price");
          const title = $button.data("title");
          window.dataLayer.push({
            "event": "ga4Event",
            "event_name": "view_item_list",
            "event_parameters": {
              "page_group": `Blog_${sku}`,
              "item_list_name": 'Blog_video_pop',
              "currency": `${$('.blog-video-model').data('currency')}`,
              "items": [{
                "item_id": sku,
                "item_name": title,
                "item_brand": "Eufy",
                "item_category": '',
                "item_variant": '',
                "price": price / 100,
                "index": 1
              }]
            }
          });
        }
      });
    });

    $(".blog-video-item").on("click", function () {
      $('.bvm-product-discount').html('').hide();
      $('.blog-video-model-footer').show();
      const productStatus = $(this).data("product-status");
      if (!productStatus) $('.blog-video-model-footer').hide();
      const index = $(this).data("idx");
      const offValue = $(this).data("off-value");
      const discount = $(this).data("discount");
      const $model = $(this).parents(".blog-video-list").siblings(".blog-video-model");
      $('.blog-video-model .bvm-product-sub-btn').attr("data-idx", index);
      if (offValue) $model.find('.bvm-product-discount').html(offValue).show();
      if (discount) $model.find('.bvm-product-btn').attr("data-discount", discount);
      $(".blog-video-model").show();
      idx = index;
      _this.modelInit(idx);

      // initYTVideoPlayer();
      window.addEventListener('youTubeIframeAPIReady' ,initYTVideoPlayer())

      const $el = $('.blog-video-model .bvm-product')[0]
      io.observe($el)

      pageHandle = $(this).data("handle");
      done = true;
    });

    $(".video-item-title").on("click", function (e) {
      const href = $(this).data("href");
      e.stopPropagation()
      e.preventDefault()
      window.location.href = href + '?ref=blog'
    });

    $(".bvm-prev").on("click", function () {
      $('.bvm-product-discount').html('').hide();
      if (idx <= 0) return;
      idx = idx - 1;
      _this.modelInit(idx);
      handleDiscount(idx);
      handleProductExist(idx);
      handleTrackData(idx);
      const $el = $('.blog-video-model .bvm-product')[0]
      io.unobserve($el);
      io.observe($el);

      ytPlayer && ytPlayer.destroy();
      initYTVideoPlayer();
      done = true;
    });

    $(".bvm-next").on("click", function () {
      $('.bvm-product-discount').html('').hide();
      if (idx >= _this.max) return;
      idx = idx + 1;
      _this.modelInit(idx);
      handleDiscount(idx);
      handleProductExist(idx);
      handleTrackData(idx);
      const $el = $('.blog-video-model .bvm-product')[0]
      io.unobserve($el);
      io.observe($el);

      ytPlayer && ytPlayer.destroy();
      initYTVideoPlayer();
      done = true;
    });

    const onPlayerReady = (event) => {
      ytPlayer = event.target;
      const $model = $(".blog-video-model");
      const vid = $model.attr('data-vid');
      ytPlayer.loadVideoById(vid);
    }

    function initYTVideoPlayer() {
      const $model = $(".blog-video-model");
      let $ytPlayerEl = $model.find(".bvm-ytb");
      youtubePlayer = new YT.Player($ytPlayerEl[0], {
          width: 560,
          height: 315,
          events: {
            onReady: onPlayerReady,
            onStateChange: (event) => {
              if (event.data == YT.PlayerState.PLAYING && done) {
                // console.log('PLAYING---')
                window.dataLayer.push({
                  "event": "uaEvent",
                  "eventCategory": "video",
                  "eventAction": "start",
                  "eventLabel": event.target.videoTitle, //视频title
                  "nonInteraction": false
                })
                window.dataLayer.push({ "event_parameters": null });
                window.dataLayer.push({
                  "event": "ga4Event",
                  "event_name": "lp_button",
                  "event_parameters": {
                    "page_group": pageHandle === 'home' ? 'Blog' : "Activity Page_"+ pageHandle,//如果是首页，则传"Home Page"
                    "position": event.target.videoTitle, //视频title
                    "button_name": "video"
                  }
                });
              }
            }
          },
      })
    }

    /**
     * 埋点数据
     */
    function handleTrackData(idx) {
      const $model = $(".blog-video-model");
      const $target = $(`.blog-video-item[data-idx=${idx}]`).eq(0);
      const product = $target.data("product") || "";
      const productJson = JSON.parse(product) || {};
      $model.find(".bvm-product-btn").attr("data-vid", productJson.v_id).attr("data-sku", productJson.v_sku).attr("data-price", productJson.v_price).attr("data-handle", productJson.v_handle).attr("data-title", productJson.title);
    }

    function handleProductExist(idx) {
      $('.blog-video-model-footer').show();
      const $target = $(`.blog-video-item[data-idx=${idx}]`).eq(0);
      const productStatus = $target.data("product-status");
      if (!productStatus) $('.blog-video-model-footer').hide();
    }

    function handleDiscount(idx) {
      const $model = $(".blog-video-model");
      const $target = $(`.blog-video-item[data-idx=${idx}]`).eq(0);
      $model.find('.bvm-product-sub-btn').attr("data-idx", idx);
      const offValue = $target.data("off-value");
      const discount = $target.data("discount");
      const product = $target.data("product") || "";
      const productJson = JSON.parse(product) || {};
      if (productJson.available) $model.find(".bvm-product-btn").show()
      $model.find('.bvm-product-btn').removeAttr("data-discount")
      if (offValue) $target.parents(".blog-video-list").siblings(".blog-video-model").find('.bvm-product-discount').html(offValue).show();
      if (discount) $model.find('.bvm-product-btn').attr("data-discount", discount);
    }

    $(".bvm-close-btn").on("click", function () {
      done = false;
      ytPlayer && ytPlayer.destroy();
      $(".blog-video-model").hide();
    });
  },
  modelInit(idx) {
    const $model = $(".blog-video-model");
    const $target = $(`.blog-video-item[data-idx=${idx}]`).eq(0);
    const product = $target.data("product") || "";
    const video = $target.data("video") || "";
    const data = {
      product: JSON.parse(product) || {},
      video: JSON.parse(video) || {},
    };

    // console.log("model idx", idx);
    if (idx === 1) {
      $(".bvm-prev").hide();
    } else if (idx === this.max) {
      $(".bvm-next").hide();
    } else {
      $(".bvm-ctrl-btn").show();
    }
    $model
      .find(".bvm-title")
      .text(decodeURIComponent(data.video.title).replaceAll("+", " "));
    $model
      .find(".bvm-desc")
      .text(decodeURIComponent(data.video.desc).replaceAll("+", " "));
    $model.find(".bvm-author").text(data.video.author);
    $model.find(".bvm-ytb").attr("src", data.video.url);
    const videoId = data.video.url.split('/').pop();
    $model.attr("data-vid", videoId);
    $model.find(".bvm-tag").text(data.video.tag);

    $model.find(".bvm-product-img").attr("src", data.product.poster);
    $model.find(".bvm-product-title").text(data.product.title);
    $model.find(".bvm-product-desc").text(data.product.desc);
    // console.log(data, '----')
    // data.product.lp
    //   ? $model.find(".bvm-product-sub-btn").attr("href", data.product.lp).show()
    //   : $model.find(".bvm-product-sub-btn").attr("href", "").hide();
    $model.find(".bvm-product-sub-btn").attr("href", data.product.url);
    $model.find(".bvm-product-btn").attr("data-vid", data.product.v_id).attr("data-sku", data.product.v_sku).attr("data-price", data.product.v_price).attr("data-handle", data.product.v_handle).attr("data-title", data.product.title);
    $model.find(".bvm-product-btn").show()
    if (!data.product.available) $model.find(".bvm-product-btn").hide()
  },
};

BlogVideoModel.init();

function buyNow(v_id, discount, authorization, currency) {
  let line_items = [{
    variant_id: v_id,
    quantity: 1
  }
  ]
  Shopify.theme.bundleBuynow({
    authorization: authorization,
    checkout: {
      line_items: line_items,
      presentment_currency: currency,
      is_upstream_button: true,
      page_type: "product",
      secret: true,
      discount_code: discount,
      wallet_name: "Checkout"
    },
    onSuccess: () => {},
  });
}

function addBuyNowTrack ({ sku, name, price, handle, discount, coupon }, itemListName, currency) {
  window.dataLayer.push({ "event_parameters": null });
  window.dataLayer.push({
    "event": "ga4Event",
    "event_name": "begin_checkout",//如果是加购,则传add_to_cart
    "event_parameters": {
      "page_group": "Blog_" + handle, //如果是活动页，改为"Activity Page_" + $Pagehandle；如果是首页，传“Home Page"
      "currency": currency,
      "value": price / 100,
      "coupon": discount,
      "item_list_name": itemListName,
      "items": [{
        "item_id": sku, //产品SKU
        "item_name": name,
        "item_brand": 'Eufy',
        "item_category": '',
        "item_variant": '',
        "price": price / 100,
        "coupon": discount,
        "discount": coupon,
        "quantity": 1
      }]
    }
  });
}

function addLearnMoreTrack ({ sku, name, price, handle, index }, itemListName, currency) {
  window.dataLayer.push({ "event_parameters": null });
  window.dataLayer.push({
    "event": "ga4Event",
    "event_name": "select_item",
    "event_parameters": {
      "page_group": "Blog_" + handle,
      "currency": currency,
      "item_list_name": itemListName,//特别注意：该变量传值以活动埋点文档要求为准，如活动埋点文档中未写定传值，则传该模块的小标题
      "items": [{
        "item_id": sku,//SKU
        "item_name": name,
        "item_brand": 'Eufy',
        "item_category": '',//产品品类
        "item_variant": '',
        "price": price / 100,
        "index": index
      }]
    }
  });
}

$(".blog-category-more-btn").on("click", function () {
  $(this).hide();
  // console.log(1111);
  $(".blog-video-item").each(function () {
    window.screen.width > 769 ? $(this).attr("data-visiable", true) : $(this).attr("data-mob-visiable", true)
  });
});

$(".blog-wrap .blog-title").on("click", function () {
  window.location.href = '/blogs/all'
});

function refTrackParam(href, newParameter) {
  let newURL;
  if (href.indexOf('?') !== -1) {
    newURL = href + '&' + newParameter;
  } else {
    newURL = href + '?' + newParameter;
  }
  return newURL;
}

$(".blog-video-model .bvm-product-btn").on("click", function () {
  const authorization = $('.blog-video-model').data('authorization')
  const currency = $('.blog-video-model').data('currency')
  const discount = $(this).data('discount')
  const coupon = $(this).parents('.bvm-product').find('.bvm-product-discount').text()
  const v_id = $(this).data('vid')
  const sku = $(this).data('sku')
  const price = $(this).data('price')
  const handle = $(this).data('handle')
  const title = $(this).data('title')
  addBuyNowTrack({ sku, price, handle, name: title, discount, coupon }, 'Blog_video_pop', currency)
  buyNow(v_id, discount, authorization, currency)
});

$(".blog-video-model .bvm-product-sub-btn").on("click", function (e) {
  e.preventDefault();
  const currency = $('.blog-video-model').data('currency')
  const $button = $(this).siblings('.bvm-product-btn')
  const index = $button.data('index')
  const sku = $button.data('sku')
  const price = $button.data('price')
  const handle = $button.data('handle')
  const title = $button.data('title')
  addLearnMoreTrack({ sku, price, handle, name: title, index }, 'Blog_video_pop', currency)
  window.location.href = refTrackParam($(this).attr('href'), 'ref=blog')
});

$(".blog-category-main .brs-product-btn").on("click", function () {
  const authorization = $('.blog-category-main').data('authorization')
  const currency = $('.blog-category-main').data('currency')
  const discount = $(this).data('discount')
  const v_id = $(this).data('vid')
  const sku = $(this).data('sku')
  const coupon = $(this).data('coupon')
  const price = $(this).data('price')
  const handle = $(this).data('handle')
  const title = $(this).data('title')
  const itemListName = $(this).parents('.brs-products').siblings('.blog-sidebar-title').text()
  addBuyNowTrack({ sku, price, handle, name: title, discount, coupon }, itemListName, currency)
  buyNow(v_id, discount, authorization, currency)
});

$(".blog-category-main .brs-product-sub-btn").on("click", function (e) {
  e.preventDefault();
  const currency = $('.blog-category-main').data('currency')
  const $button = $(this).siblings('.brs-product-btn')
  const index = $button.data('index')
  const sku = $button.data('sku')
  const price = $button.data('price')
  const handle = $button.data('handle')
  const title = $button.data('title')
  const itemListName = $(this).parents('.brs-products').siblings('.blog-sidebar-title').text()
  addLearnMoreTrack({ sku, price, handle, name: title, index }, itemListName, currency)
  window.location.href = refTrackParam($(this).attr('href'), 'ref=blog')
});

$(".article-main .brs-product-btn").on("click", function () {
  const authorization = $('.article-main').data('authorization')
  const currency = $('.article-main').data('currency')
  const discount = $(this).data('discount')
  const coupon = $(this).data('coupon')
  const v_id = $(this).data('v-id')
  const sku = $(this).data('sku')
  const price = $(this).data('price')
  const handle = $(this).data('handle')
  const title = $(this).data('title')
  const itemListName = $(this).parents('.brs-products').siblings('.blog-sidebar-title').text()
  addBuyNowTrack({ sku, price, handle, name: title, discount, coupon }, itemListName, currency)
  buyNow(v_id, discount, authorization, currency)
});

$(".article-main .brs-product-sub-btn").on("click", function (e) {
  e.preventDefault();
  const currency = $('.article-main').data('currency')
  const $button = $(this).siblings('.brs-product-btn')
  const index = $button.data('index')
  const sku = $button.data('sku')
  const price = $button.data('price')
  const handle = $button.data('handle')
  const title = $button.data('title')
  const itemListName = $(this).parents('.brs-products').siblings('.blog-sidebar-title').text()
  addLearnMoreTrack({ sku, price, handle, name: title, index }, itemListName, currency)
  window.location.href = refTrackParam($(this).attr('href'), 'ref=blog')
});
